export const environment = {
  production: true,
  urlBase: 'https://api.meurhonline.com.br/',
};
